import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M12.2,7.1c2.1-2.1,3.9-4,5.9-6c1.4-1.4,2.1-1.4,3.5,0c0.9,0.9,1.7,1.7,2.6,2.6c1.1,1.1,1.1,2,0,3.1c-2,2-3.9,4-5.8,5.9 c0,0,0,0.1-0.1,0.3c1.9,1.9,3.8,3.8,5.7,5.7c1.4,1.5,1.5,2.1,0.1,3.5c-3.7,3.7-3.4,3.9-7.1,0.1c-1.3-1.4-2.6-2.7-4.1-4.2 c-2.1,2.1-4,4-5.9,5.9c-1.4,1.4-2.1,1.4-3.5,0c-0.9-0.8-1.7-1.7-2.6-2.6c-1.1-1.1-1.1-2.1,0-3.1c2-1.9,3.9-3.9,6.1-6.1 c-2-2-3.9-3.9-5.8-5.8c-1.6-1.6-1.6-2.1,0-3.7c3.5-3.6,3.3-3.6,6.8,0C9.3,4.2,10.7,5.5,12.2,7.1" />
    </g>
  </svg>
);
